export const iconFontAwesomeUsersPeopleHouseChimneyUser = (
	<i className="fa-solid fa-house-chimney-user"></i>
);
